import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { PageHeader, StatusBadge, fmtDate } from "@/components/ui-bits";
import { Field } from "@/pages/Login";

export default function Support() {
  const [tickets, setTickets] = useState([]);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  const load = async () => { const { data } = await api.get("/support/tickets/mine"); setTickets(data); };
  useEffect(() => { load(); }, []);

  const submit = async () => {
    if (!subject.trim() || !message.trim()) return toast.error("Subject and message required");
    setBusy(true);
    try {
      await api.post("/support/tickets", { subject, message });
      toast.success("Ticket submitted"); setSubject(""); setMessage(""); load();
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };

  return (
    <div>
      <PageHeader title="Support" subtitle="Open a ticket. Our team typically replies within 24h." />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        <div className="glass p-5">
          <h3 className="font-display text-lg font-bold mb-4">Create Ticket</h3>
          <div className="space-y-3">
            <Field label="Subject" value={subject} onChange={setSubject} testid="ticket-subject" />
            <div>
              <span className="text-xs uppercase tracking-[0.18em] text-[#94A3B8] font-bold">Message</span>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={5}
                data-testid="ticket-message"
                className="mt-2 w-full bg-[#0A132A] border border-white/10 rounded-lg px-4 py-2.5 text-white placeholder:text-[#475569] focus:outline-none focus:border-[#00F0FF] focus:ring-1 focus:ring-[#00F0FF] transition-all"
              />
            </div>
            <button onClick={submit} disabled={busy} data-testid="ticket-submit"
                    className="w-full py-3 rounded-lg bg-[#00F0FF] text-[#060B19] font-bold hover:bg-[#00D4E0] transition-all disabled:opacity-50">
              {busy ? "Submitting…" : "Submit Ticket"}
            </button>
          </div>
        </div>
        <div className="glass p-5 lg:col-span-2">
          <h3 className="font-display text-lg font-bold mb-4">My Tickets</h3>
          <div className="space-y-3 max-h-[600px] overflow-y-auto pr-1" data-testid="my-tickets">
            {tickets.map((t) => (
              <div key={t.id} className="border border-white/10 rounded-lg p-4">
                <div className="flex items-start justify-between">
                  <div>
                    <div className="font-semibold">{t.subject}</div>
                    <div className="text-xs text-[#94A3B8] mt-1">{fmtDate(t.created_at)}</div>
                  </div>
                  <StatusBadge status={t.status} />
                </div>
                <div className="text-sm text-[#94A3B8] mt-3 whitespace-pre-line">{t.message}</div>
                {t.replies?.length > 0 && (
                  <div className="mt-4 space-y-2 border-t border-white/5 pt-3">
                    {t.replies.map((r, i) => (
                      <div key={i} className="bg-[#00F0FF]/5 border-l-2 border-[#00F0FF]/40 px-3 py-2 rounded-r">
                        <div className="text-xs text-[#00F0FF] uppercase tracking-wider font-bold">{r.by} · {fmtDate(r.created_at)}</div>
                        <div className="text-sm mt-1">{r.message}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
            {tickets.length === 0 && <div className="text-[#475569] text-sm py-6 text-center">No tickets yet</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
